import ExecutionsLandingPage from '../pages/executions/ExecutionsLandingPage';
import ExecutionSummaryPage from '../pages/executions/ExecutionSummaryPage';
import ExecutionRuleFailuresPage from '../pages/executions/ExecutionRuleFailuresPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import NotFound404 from '../pages/not-found-404';
import { EXECUTIONS, EXECUTION_SUMMARY, EXECUTION_RULE_FAILURES } from './links';

function MainPageNavigator(): JSX.Element {
  return (
    <Routes>
      <Route path={''} element={<Navigate to={EXECUTIONS} replace />} />
      <Route path={EXECUTIONS} element={<ExecutionsLandingPage />} />
      <Route path={EXECUTION_SUMMARY} element={<ExecutionSummaryPage />} />
      <Route path={EXECUTION_RULE_FAILURES} element={<ExecutionRuleFailuresPage />} />
      <Route path='*' element={<NotFound404 />} />
    </Routes>
  );
}

export default MainPageNavigator;
